;(function($, window, document){
    window.Slideshow = Me.view.extend({
        options: {
            currentSlide: 1
        },

        initialize: function() {
            _.bindAll(this, 'previousSlide', 'nextSlide', 'navigateToSlide', 'update');
            this.addEvents();
        },
        addEvents: function() {
            this.$('.arrow-button.left').on('click', this.previousSlide);
            this.$('.arrow-button.right').on('click', this.nextSlide);

            if(this.$('.slides-count').length != 0){
                this.$('.slides-count a').on('click', this.navigateToSlide);
            }
        },
        navigateToSlide: function(e){
            this.options.currentSlide = $(e.currentTarget).index() + 1;

            this.update();
        },
        previousSlide: function(e){
            this.options.currentSlide --;

            if(this.options.currentSlide <= 0){
                this.options.currentSlide = this.$('.slideshow-images .slide').length;
            }

            this.update();
        },
        nextSlide: function(e){
            this.options.currentSlide ++;

            if(this.options.currentSlide > this.$('.slideshow-images .slide').length){
                this.options.currentSlide = 1;
            }

            this.update();
        },
        update: function(){
            if(this.$el.parents('.configurator').length != 0){
                Me.track.event('Product', 'slideshow');
            }

            if(this.$('.slides-count').length != 0){
                this.$('.slides-count a span.active').removeClass('active');
                this.$('.slides-count a:eq(' + (this.options.currentSlide-1) + ')').find('>span').addClass('active');
            }

            this.$('.slide.active').removeClass('active');
            this.$('.slideshow-images .slide:eq(' + (this.options.currentSlide-1) + ')').addClass('active');
            this.$('.slideshow-content .slide:eq(' + (this.options.currentSlide-1) + ')').addClass('active');

            if(this.$('.current-page').length != 0){
                this.$('.current-page').html(this.options.currentSlide);
            }

        }
    });
}(jQuery, window, document));
